module.exports = __webpack_public_path__ + "img/filter.8b1af9b0.svg";